import { useTranslation } from 'react-i18next'

export default function BoatRacingDetailT10() {
	const { t } = useTranslation()
	return (
		<div className='boat-racing-detail-t10'>
			<div className='content-detail'>
				<span className='text-detail'>
					{t('event.event_boa_racing_t10.rules')}
				</span>

				<div className='list-content'>
					<h4>{t('event.event_boa_racing_t10.boun_suang_heua_event')}</h4>
					<ol>
						<li>
							<strong>{t('event.event_boa_racing_t10.event_duration')}</strong><br />
							<ul>
								<li>
									{t('event.event_boa_racing_t10.the_event_will_take_place_from_october_1_2025_until_23_59_59_on_october_31_2025')}
								</li>
							</ul>
						</li>
						<li>
							<strong>
								{t('event.event_boa_racing_t10.eligibility')}
							</strong><br />
							<ul>
								<li>
									{t('event.event_boa_racing_t10.this_event_applies_only_to_unitel_subscribers_who_are_currently_using_the_service')}
								</li>
								<li>
									{t('event.event_boa_racing_t10.participants_must_maintain_an_active_daily_sub_package_throughout_the_gameplay_period_in_order_for_their_results_to_be_recorded')}
								</li>
							</ul>
						</li>
						<li>
							<strong>
								{t('event.event_boa_racing_t10.game_rules')}
							</strong>
							<ul>
								<li>
									{t('event.event_boa_racing_t10.players_will_participate_in_the_boat_racing_game_within_the_event_webgame')}
								</li>
								<li>
									{t('event.event_boa_racing_t10.boat_collection_rules')}:
								</li>
								<li className='level-3'>
									{t('event.event_boa_racing_t10.winning_a_match_randomly_receive_3_to_5_boats')}
								</li>
								<li className='level-3'>
									{t('event.event_boa_racing_t10.losing_a_match_receive_1_boat')}
								</li>
								<li>
									{t('event.event_boa_racing_t10.the_player_who_collects_the_highest_number_of_boats_during_the_entire_event_period_will_be_declared_the_winner')}
								</li>
							</ul>
						</li>
						<li>
							<strong>
								{t('event.event_boa_racing_t10.prizes')}
							</strong>
							<ul>
								<li>
									{t('event.event_boa_racing_t10.there_will_be_one_special_prize_for_the_best_player_a_xiaomi_redmi_14c_4gb_128gb_smartphone_valued_at_2299000_kip')}
								</li>
								<li>
									{t('event.event_boa_racing_t10.second_prize')}
								</li>
								<li>
									{t('event.event_boa_racing_t10.third_prize')}
								</li>
							</ul>
						</li>
						<li>
							<strong>
								{t('event.event_boa_racing_t10.winner_determination')}
							</strong>
							<ul>
								<li>
									{t('event.event_boa_racing_t10.the_results_will_be_compiled_and_announced_at_23_59_59_on_october_31_2025')}
								</li>
								<li>
									{t('event.event_boa_racing_t10.in_the_event_of_a_tie_in_the_number_of_boats_collected_the_deciding_factor_will_be_the_time_of_collecting_the_last_boat_the_player_who_collects_the_final_boat_earlier_will_be_declared_the_winner')}
								</li>
							</ul>
						</li>
						<li>
							<strong>
								{t('event.event_boa_racing_t10.general_terms')}
							</strong>
							<ul>
								<li>
									{t('event.event_boa_racing_t10.unitel_is_the_sole_entity_with_the_final_decision_making_authority_regarding_the_event_results_and_prizes')}
								</li>
								<li>
									{t('event.event_boa_racing_t10.unitel_will_directly_contact_the_winner_to_proceed_with_prize_distribution_in_accordance_with_the_regulations')}
								</li>
								{/* <li>
									{t('event.event_boa_racing_t10.congratulations_you_have_rightfully_won_the_first_prize_a_xiaomi_redmi_14c_4gb_128gb_from_the_boun_suang_heua_festival_unitel_will_contact_you_shortly_to_deliver_your_reward')}
								</li> */}
							</ul>
						</li>
					</ol>
				</div>
			</div>
		</div>
	)
}
